module.exports = __webpack_public_path__ + "static/img/login.620b4b08.png";